import type { ComponentType } from 'react'

import { SalesStatisticsSourcesTabs } from '../bindings/receipts/SalesStatisticsTabs'

/**
 * Шапка входа раздела над выбором источника: у раздела, где кроме источников есть ещё вид (табы), её даёт composition — платформенная
 * привязка входа о видах раздела не знает.
 */
export const SECTION_HEADERS: Readonly<Record<string, ComponentType>> = {
  'sales-statistics': SalesStatisticsSourcesTabs,
}
